/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SubmitApplicationDecision = 'NotSet' | 'Invalid' | 'Approved' | 'Declined' | 'Review' | 'Error' | 'CounterOffer';

export const SubmitApplicationDecision = {
    NotSet: 'NotSet' as SubmitApplicationDecision,
    Invalid: 'Invalid' as SubmitApplicationDecision,
    Approved: 'Approved' as SubmitApplicationDecision,
    Declined: 'Declined' as SubmitApplicationDecision,
    Review: 'Review' as SubmitApplicationDecision,
    Error: 'Error' as SubmitApplicationDecision,
    CounterOffer: 'CounterOffer' as SubmitApplicationDecision
}